"use client";

import NextError from "next/error";
import { useChunkErrorRecovery } from "./_components/chunkReload";

export default function GlobalError({ error }) {
  const isRecovering = useChunkErrorRecovery(error);

  // global-error replaces the root layout, so globals.css isn't loaded here —
  // style the reloading state inline rather than with Tailwind utilities.
  return (
    <html lang="en">
      <body>
        {isRecovering ? (
          <p
            style={{
              fontFamily: "system-ui, sans-serif",
              fontSize: "13px",
              color: "#6b7280",
              padding: "24px",
              textAlign: "center",
            }}
          >
            Updating to the latest version…
          </p>
        ) : (
          <NextError />
        )}
      </body>
    </html>
  );
}
